<script lang="ts">
  import SectionTitle from "@kontextwerk/web-sdk/ui/typography/SectionTitle.svelte"
  import { resolveAppointmentContact } from "../../../../../../../../../_shared/_logic/appointment-contact"

  type Props = {
    event?: ScheduleEvent | null
    workOrder?: WorkOrder | null
    customers?: Customer[]
    contactPoints?: ContactPoint[]
  }

  const { event = null, workOrder = null, customers = [], contactPoints = [] }: Props = $props()

  const customersById = $derived(
    Object.fromEntries((customers ?? []).map((customer) => [customer.id, customer])),
  )
  const appointmentContact = $derived(
    resolveAppointmentContact({
      event,
      workOrder,
      customersById,
      contactPoints,
    }),
  )
  const hasParticipantInfo = $derived(
    Boolean(
      appointmentContact?.confirmedByLabel ||
      appointmentContact?.contactName ||
      appointmentContact?.contactPhone ||
      appointmentContact?.contactEmail,
    ),
  )
</script>

{#if hasParticipantInfo}
  <section class="appointment-contact">
    <SectionTitle
      small={true}
      title="Termin-Teilnehmer"
      style="margin-top: 0.9rem; margin-bottom: 0.2rem;"
    />
    <dl class="appointment-contact__facts">
      {#if appointmentContact?.confirmedByLabel}
        <div>
          <dt>Bestätigt durch</dt>
          <dd>{appointmentContact.confirmedByLabel}</dd>
        </div>
      {/if}
      {#if appointmentContact?.contactName}
        <div>
          <dt>Vor Ort</dt>
          <dd>{appointmentContact.contactName}</dd>
        </div>
      {/if}
      {#if appointmentContact?.contactPhone}
        <div>
          <dt>Telefon</dt>
          <dd>{appointmentContact.contactPhone}</dd>
        </div>
      {/if}
      {#if appointmentContact?.contactEmail}
        <div>
          <dt>E-Mail</dt>
          <dd>{appointmentContact.contactEmail}</dd>
        </div>
      {/if}
    </dl>
  </section>
{/if}

<style lang="less">
  .appointment-contact {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    color: var(--overlay-text-color, var(--text-100));
  }

  .appointment-contact__facts {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 0.45rem 1rem;
    margin: 0;
  }

  .appointment-contact__facts div {
    min-width: 0;
  }

  .appointment-contact__facts dt {
    margin: 0;
    color: color-mix(in srgb, var(--overlay-text-color, var(--text-100)) 72%, transparent);
    font-size: 0.72rem;
    font-weight: 800;
    text-transform: uppercase;
  }

  .appointment-contact__facts dd {
    margin: 0;
    line-height: 1.35;
  }

  .appointment-contact__facts dd {
    overflow-wrap: anywhere;
    font-weight: 700;
  }
</style>
